module.exports = __webpack_public_path__ + "static/media/frank_london.crop2.c3247eb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/frank_london.crop2.jpg
// module id = 409
// module chunks = 0